import React from 'react';
import ReactDOM from 'react-dom';
import CartNext from './CartNext';

// Self-mount into the cart-next template's root. React/ReactDOM are UMD globals.
function mount() {
  const el = document.getElementById('cart-next-root');
  if (!el) return;
  if (ReactDOM.createRoot) {
    ReactDOM.createRoot(el).render(<CartNext />);
  } else {
    ReactDOM.render(<CartNext />, el);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}

export default CartNext;
